module.exports = __webpack_public_path__ + "static/media/icon-pill-racquetball.6ff19a23.svg";